import { render } from "./PaperUser.vue?vue&type=template&id=4958fea9"
import script from "./PaperUser.vue?vue&type=script&lang=js"
export * from "./PaperUser.vue?vue&type=script&lang=js"

import "./PaperUser.vue?vue&type=style&index=0&id=4958fea9&lang=less"

import exportComponent from "/codebuild/output/src3396806294/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__